"use client";

import { Guarantee as GuaranteeComponent } from "@/composite/Guarantee";
import type { Guarantee } from "@/types/references";

import styles from "./styles.module.scss";

interface GuaranteeBlockClientProps {
	guarantees: Guarantee[];
}

/**
 * Guarantee block component
 */
export function GuaranteeBlock(props: GuaranteeBlockClientProps): JSX.Element {
	return (
		<div className={styles["guarantees"]}>
			{props.guarantees.map((guarantee, index) => (
				<GuaranteeComponent
					key={index}
					icon={{
						name: guarantee.icon.icon_name as string
					}}
					label={guarantee.label}
				/>
			))}
		</div>
	);
}
